/* ARG Healthcare UI helpers — ~3KB, no dependencies */
(function(){
  'use strict';
  var d=document;

  /* Tabs */
  function initTabs(root){
    var tabs=root.querySelectorAll('[role="tab"]');
    tabs.forEach(function(t){
      t.addEventListener('click',function(){
        tabs.forEach(function(x){
          var on=x===t;x.setAttribute('aria-selected',on);x.tabIndex=on?0:-1;
          var p=d.getElementById(x.getAttribute('aria-controls'));if(p)p.hidden=!on;
        });
      });
    });
  }

  /* Banner slider */
  function initBanner(root){
    var track=root.querySelector('.arg-banner__track'),slides=root.querySelectorAll('.arg-banner__slide'),dots=root.querySelectorAll('.arg-banner__dots button');
    if(!track||slides.length<2)return;
    var i=0,timer,delay=(+root.dataset.delay||5)*1000;
    function go(n){i=(n+slides.length)%slides.length;track.scrollTo({left:track.clientWidth*i,behavior:'smooth'});mark()}
    function mark(){dots.forEach(function(b,k){b.setAttribute('aria-current',k===i)})}
    dots.forEach(function(b,k){b.addEventListener('click',function(){go(k);restart()})});
    track.addEventListener('scroll',function(){var n=Math.round(track.scrollLeft/track.clientWidth);if(n!==i){i=n;mark()}},{passive:true});
    function restart(){clearInterval(timer);if(!matchMedia('(prefers-reduced-motion: reduce)').matches)timer=setInterval(function(){go(i+1)},delay)}
    root.addEventListener('mouseenter',function(){clearInterval(timer)});root.addEventListener('mouseleave',restart);
    mark();restart();
  }

  /* Videos: load + play only when visible */
  var vio='IntersectionObserver' in window?new IntersectionObserver(function(es){
    es.forEach(function(e){var v=e.target;
      if(e.isIntersecting){if(!v.src&&v.dataset.src){v.src=v.dataset.src}var p=v.play();if(p&&p.catch)p.catch(function(){})}
      else if(!v.paused){v.pause()}
    });
  },{rootMargin:'120px'}):null;

  /* Store network filter */
  function initNet(root){
    var q=root.querySelector('[data-net-search]'),btns=root.querySelectorAll('[data-net-filter]'),cards=root.querySelectorAll('.arg-store'),empty=root.querySelector('.arg-empty'),type='all';
    function run(){
      var term=(q&&q.value||'').trim().toLowerCase(),shown=0;
      cards.forEach(function(c){var ok=(type==='all'||c.dataset.type===type)&&(!term||c.dataset.search.indexOf(term)>-1);c.hidden=!ok;if(ok)shown++});
      if(empty)empty.hidden=shown>0;
    }
    btns.forEach(function(b){b.addEventListener('click',function(){type=b.dataset.netFilter;btns.forEach(function(x){x.setAttribute('aria-pressed',x===b)});run()})});
    if(q)q.addEventListener('input',run);
  }

  /* Map: load iframe on click / when near viewport (saves ~500KB) */
  function initMap(btn){
    function load(){var f=d.createElement('iframe');f.src=btn.dataset.map;f.loading='lazy';f.title=btn.dataset.title||'Map';f.referrerPolicy='no-referrer-when-downgrade';f.allowFullscreen=true;btn.replaceWith(f)}
    btn.addEventListener('click',load);
  }

  function boot(scope){
    scope=scope||d;
    scope.querySelectorAll('[data-arg-tabs]').forEach(initTabs);
    scope.querySelectorAll('[data-arg-banner]').forEach(initBanner);
    scope.querySelectorAll('[data-arg-net]').forEach(initNet);
    scope.querySelectorAll('[data-map]').forEach(initMap);
    scope.querySelectorAll('video[data-arg-lazy]').forEach(function(v){if(vio)vio.observe(v);else if(v.dataset.src)v.src=v.dataset.src});
    scope.querySelectorAll('[data-arg-vt-toggle]').forEach(function(b){b.addEventListener('click',function(){var v=b.previousElementSibling;v.muted=!v.muted;if(v.paused)v.play()})});
    if(d.querySelector('.arg-sticky-call'))d.body.classList.add('arg-has-sticky');
    if('IntersectionObserver' in window&&!matchMedia('(prefers-reduced-motion: reduce)').matches){
      var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target)}})},{rootMargin:'0px 0px -8% 0px'});
      scope.querySelectorAll('.arg-sec>.arg-wrap,.arg-band,.arg-store').forEach(function(el){
        if(el.getBoundingClientRect().top>innerHeight){el.classList.add('arg-rv');io.observe(el)}
      });
    }
  }
  if(d.readyState!=='loading')boot();else d.addEventListener('DOMContentLoaded',function(){boot()});
  d.addEventListener('shopify:section:load',function(e){boot(e.target)});
})();
